import React from 'react';
import QueueAnim from 'rc-queue-anim';

const Error403 = () => (
  <div className="err-container text-center">
    <div className="err">
      <h1>403</h1>
      <h2>Sorry, you are not allowed here!</h2>
    </div>

    <div className="err-body">
      <a href="#/" className="btn btn-raised btn-lg btn-default">
          Go Back to Home Page
      </a>
    </div>
  </div>
);

const Page403 = () => (
  <div className="page-err">
    <QueueAnim type="bottom" className="ui-animate">
      <div key="1">
        <Error403 />
      </div>
    </QueueAnim>
  </div>
);

module.exports = Page403;



// WEBPACK FOOTER //
// ./routes/403/components/403.js